!function (e) {
  var a = "(?:(?!\\s)[\\d$+<=a-zA-Z\\x80-\\uFFFF])+",
    t = "[^{}@#]+\\{[^}#@]*\\}";
  e.languages.cooklang = {
    comment: {
      pattern: /\[-[\s\S]*?-\]|--.*/,
      greedy: !0
    },
    meta: {
      pattern: />>.*:.*/,
      inside: {
        property: {
          pattern: /(>>\s*)[^\s:](?:[^:]*[^\s:])?/,
          lookbehind: !0
        }
      }
    },
    "cookware-group": {
      pattern: new RegExp("#(?:" + t + "|" + a + ")"),
      inside: {
        cookware: {
          pattern: new RegExp("(^#)(?:[^{}@#]+)"),
          lookbehind: !0,
          alias: "variable"
        },
        "cookware-keyword": {
          pattern: /^#/,
          alias: "keyword"
        },
        "quantity-group": {
          pattern: new RegExp(/\{[^{}@#]*\}/),
          inside: {
            quantity: {
              pattern: new RegExp("(^\\{)[^{}@#]+"),
              lookbehind: !0,
              alias: "number"
            },
            punctuation: /[{}]/
          }
        }
      }
    },
    "ingredient-group": {
      pattern: new RegExp("@(?:" + t + "|" + a + ")"),
      inside: {
        ingredient: {
          pattern: new RegExp("(^@)(?:[^{}@#]+)"),
          lookbehind: !0,
          alias: "variable"
        },
        "ingredient-keyword": {
          pattern: /^@/,
          alias: "keyword"
        },
        "amount-group": {
          pattern: /\{[^{}]*\}/,
          inside: {
            amount: {
              pattern: /([\{|])[^{}|*%]+/,
              lookbehind: !0,
              alias: "number"
            },
            unit: {
              pattern: /(%)[^}]+/,
              lookbehind: !0,
              alias: "symbol"
            },
            "servings-scaler": {
              pattern: /\*/,
              alias: "operator"
            },
            "servings-alternative-separator": {
              pattern: /\|/,
              alias: "operator"
            },
            "unit-separator": {
              pattern: /(?:%|(\*)%)/,
              lookbehind: !0,
              alias: "operator"
            },
            punctuation: /[{}]/
          }
        }
      }
    },
    "timer-group": {
      pattern: /~(?!\s)[^@#~{}]*\{[^{}]*\}/,
      inside: {
        timer: {
          pattern: /(^~)[^{]+/,
          lookbehind: !0,
          alias: "variable"
        },
        "duration-group": {
          pattern: /\{[^{}]*\}/,
          inside: {
            punctuation: /[{}]/,
            unit: {
              pattern: new RegExp("(%\\s*)(?:h|hours|hrs|m|min|minutes)\\b"),
              lookbehind: !0,
              alias: "symbol"
            },
            operator: /%/,
            duration: {
              pattern: /\d+/,
              alias: "number"
            }
          }
        },
        "timer-keyword": {
          pattern: /^~/,
          alias: "keyword"
        }
      }
    }
  };
}(Prism);